import React from 'react'
import { Card, CardTitle, CardBody, CardImg } from 'reactstrap';
import Zoom from 'react-reveal/Zoom';
import defaultimg from '../assets/person.png'

const Img = ({name,img})=> {
    function addDefaultSrc(ev){
        ev.target.src = `https://ui-avatars.com/api/?name=${name}&length=1&background=random` || defaultimg
      }
    return (
        <Zoom>
        <div>
        <Card onContextMenu={(e)=>e.preventDefault()}>
            <CardImg top width="100%" className="rounded-circle" onError={addDefaultSrc} src={img || `https://ui-avatars.com/api/?name=${name}&length=1&background=random`} alt="Card image cap" />
            <CardBody>
            <CardTitle tag="h5" className="mt-2">{name || "name"}</CardTitle>
            </CardBody>
        </Card>
        </div>
        </Zoom>
    )
}

export default Img;